import { MotionValue } from "framer-motion"

/** @internal */
export const isMotionValue = (v: any): v is MotionValue => v instanceof MotionValue
